import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireFeatureGate } from '~/utils/guards';

const MetaDeliveryWizardPage = lazy(
  () => import('~/features/content-enrichment/pages/meta-delivery-wizard-page'),
);

/**
 * Pre-delivery wizard for the Meta Ads enrichment funnel's "Confirm &
 * Publish" action. A trailing-underscore leaf route (`$batchId_`, not
 * `$batchId`) so it escapes the sibling `$batchId.tsx` layout route's
 * `ContentEnrichmentLayout` chrome — same reasoning as the Google route.
 * Escaping that file also means its own `requireFeatureGate('meta_ads')`
 * check isn't inherited, so it's re-declared here for parity (currently a
 * no-op — `meta_ads` ships `shipped: true` in the gate registry).
 */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/meta/content-enrichment/$batchId_/deliver',
)({
  beforeLoad: async () => {
    await requireFeatureGate('delivery-wizard')();
    await requireFeatureGate('meta_ads')();
  },
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <MetaDeliveryWizardPage />
    </Suspense>
  ),
});
